export default {
  pagingProcessingProgress: '/csh5/courier/aihelper/pagingProcessingProgress'
}
